// extracted by mini-css-extract-plugin
export default {"container":"sq-z","brandName":"tq-z","productName":"uq-z","productNamePdpEnhancements":"vq-z","breakLongProductName":"wq-z"};